import { jsx as _jsx } from "react/jsx-runtime";
import { ComboboxField, useControllerMerged, } from '@baseplate-dev/ui-components';
import { useMemo, useState } from 'react';
import { ModelUtils } from '#src/definition/index.js';
import { useProjectDefinition } from '../hooks/use-project-definition.js';
function createCreateOption(value) {
    return {
        label: `Create "${value}"`,
        value,
    };
}
function ModelComboboxField({ canCreate, value, ...rest }) {
    const { definition } = useProjectDefinition();
    const [searchQuery, setSearchQuery] = useState('');
    const modelOptions = useMemo(() => {
        const baseModels = definition.models.map((model) => ({
            label: model.name,
            value: model.id,
        }));
        if (!canCreate)
            return baseModels;
        const newModelName = searchQuery ? searchQuery : value;
        const doesNewModelExist = !!baseModels.some((option) => option.label === newModelName || option.value === newModelName);
        return !doesNewModelExist &&
            newModelName &&
            ModelUtils.validateModelName(newModelName)
            ? [...baseModels, createCreateOption(newModelName)]
            : baseModels;
    }, [definition.models, searchQuery, value, canCreate]);
    return (_jsx(ComboboxField, { placeholder: "Select a model", ...rest, searchQuery: canCreate ? searchQuery : undefined, onSearchQueryChange: setSearchQuery, options: modelOptions, value: value }));
}
function ModelComboboxFieldController({ name, control, ...rest }) {
    const { field, fieldState: { error }, } = useControllerMerged({ name, control }, rest);
    const restProps = rest;
    return (_jsx(ModelComboboxField, { error: error?.message, ...restProps, ...field, value: field.value ?? null }));
}
export { ModelComboboxField, ModelComboboxFieldController };
//# sourceMappingURL=model-combobox-field.js.map